import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface TermsOfServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsOfServiceModal({
  isOpen,
  onClose
}: TermsOfServiceModalProps) {
  return <AnimatePresence data-id="element-222">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-223">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-224" />

          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-[#FAF7F2] text-[#2D1B4E] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" data-id="element-225">
            <div className="sticky top-0 bg-[#FAF7F2] border-b border-[#E8D5D5] px-6 py-4 flex items-center justify-between z-10" data-id="element-226">
              <h2 className="text-xl font-bold font-serif" data-id="element-227">Terms of Service</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-[#E8D5D5] transition-colors" aria-label="Close terms of service" data-id="element-228">
                <X className="w-5 h-5" data-id="element-229" />
              </button>
            </div>

            <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-64px)] text-sm leading-relaxed space-y-6" data-id="element-230">
              <p className="text-gray-500 text-xs" data-id="element-231">
                Last updated: February 2026
              </p>

              <section data-id="element-232">
                <h3 className="font-bold text-base mb-2" data-id="element-233">
                  1. Digital Product Delivery
                </h3>
                <p className="text-gray-700" data-id="element-234">
                  Upon completing your purchase of{' '}
                  <em data-id="element-235">From Trauma to Self-Love: Shadow Work Secrets</em>, you
                  will receive immediate access to the digital eBook and all
                  included bonus materials. Delivery is via instant download
                  link provided at checkout and sent to your email.
                </p>
              </section>

              <section data-id="element-236">
                <h3 className="font-bold text-base mb-2" data-id="element-237">2. License & Usage</h3>
                <p className="text-gray-700" data-id="element-238">
                  Your purchase grants you a personal, non-transferable license
                  to use the eBook and bonus materials for your own personal
                  development. You may not redistribute, resell, or share the
                  materials with others.
                </p>
              </section>

              <section data-id="element-239">
                <h3 className="font-bold text-base mb-2" data-id="element-240">3. Refund Policy</h3>
                <p className="text-gray-700 mb-3" data-id="element-241">
                  We want you to be completely satisfied. If you encounter an
                  issue, you must notify us within the first 7 days of purchase.
                  Once notified, and if eligible, refunds can be processed up to
                  30 days from the purchase date.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-242">
                  Refunds apply in the following cases:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2 mb-3" data-id="element-243">
                  <li data-id="element-244">
                    Technical issues preventing ebook access that cannot be
                    resolved.
                  </li>
                  <li data-id="element-245">Accidental duplicate purchases.</li>
                </ul>
                <p className="text-gray-700" data-id="element-246">
                  Contact us via WhatsApp Business at{' '}
                  <a href="https://wa.me/15512540741" target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:underline font-medium" data-id="element-247">
                    +1 551-254-0741
                  </a>{' '}
                  or email us at{' '}
                  <a href="mailto:info@dreambuk.com" className="text-[#D4A574] hover:underline font-medium" data-id="element-248">
                    info@dreambuk.com
                  </a>{' '}
                  to initiate a refund request.
                </p>
              </section>

              <section data-id="element-249">
                <h3 className="font-bold text-base mb-2" data-id="element-250">4. Disclaimer</h3>
                <p className="text-gray-700" data-id="element-251">
                  The content in this book is for educational and informational
                  purposes only. It is not a substitute for professional
                  therapy, counseling, or medical advice. If you are
                  experiencing a mental health crisis, please seek help from a
                  qualified professional.
                </p>
              </section>

              <section data-id="element-252">
                <h3 className="font-bold text-base mb-2" data-id="element-253">
                  5. Intellectual Property
                </h3>
                <p className="text-gray-700" data-id="element-254">
                  All content, including text, graphics, and design, is the
                  intellectual property of the author and is protected by
                  copyright law. Unauthorized reproduction or distribution is
                  prohibited.
                </p>
              </section>

              <section data-id="element-255">
                <h3 className="font-bold text-base mb-2" data-id="element-256">
                  6. Changes to Terms
                </h3>
                <p className="text-gray-700" data-id="element-257">
                  We reserve the right to update these terms at any time. Any
                  changes will be reflected on this page with an updated date.
                  Continued use of the product constitutes acceptance of the
                  revised terms.
                </p>
              </section>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}